import { render, staticRenderFns } from "./GroupsForUser.vue?vue&type=template&id=3087b5e6&scoped=true&"
import script from "./GroupsForUser.vue?vue&type=script&lang=js&"
export * from "./GroupsForUser.vue?vue&type=script&lang=js&"
import style0 from "./GroupsForUser.vue?vue&type=style&index=0&id=3087b5e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3087b5e6",
  null
  
)

export default component.exports